import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import DistributionPageUI from './DistributionPageUI.js'

class DistributionPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountDisbursedList: null,
      accountDisbursedListR: null,
      purposeDisbursedList: null,
      invDiscountDisbursedList: null,
      womanLedDisbursedList: null,
      totalDisbursement: null,
      financialYear: null,
      financialYearList: []
    }
  }

  render() {
    return (
      <DistributionPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        totalDisbursement={this.state.totalDisbursement}
        accountDisbursedList={this.state.accountDisbursedList}
        accountDisbursedListR={this.state.accountDisbursedListR}
        purposeDisbursedList={this.state.purposeDisbursedList}
        invDiscountDisbursedList={this.state.invDiscountDisbursedList}
        womanLedDisbursedList={this.state.womanLedDisbursedList}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
        //
        financialYear={this.state.financialYear}
        financialYearList={this.state.financialYearList}
        onFinancialYearChange={this.onFinancialYearChange}
      />
    )
  }

  onFinancialYearChange = (option) => {
    console.log("hi")
    let context = this.props.context
    this.setState({ financialYear: option.value }, () => {
      this.getDisbursements(context, context.filter)
    })
  }

  onTypeChange = (type) => {
    let context = this.props.context
    this.getDisbursements(context, type)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
    this.getDisbursements(context, context.filter)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let financialYearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    let newFinancialYearList = [{ value: null, label: 'All' }, ...financialYearList]
    this.setState({ errorList: response.errorList, financialYearList: newFinancialYearList })
  }

  getDisbursements(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/distributions`,
      cacheKey: CacheKeys.Disbursements(stp),
      callback: this.getDisbursementsCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getDisbursementsCallback = (response) => {
    let r = response.financialYearList.filter(y => y.financialYear === this.state.financialYear)[0]


    console.log('Selected Year:', this.state.financialYear);
    console.log('Found Data:', r);
    if (!r) {
      console.error('No data found for the selected financial year');
      r = {
        accountDisbursedList: [],
        purposeDisbursedList: [],
        invDiscountDisbursedList: [],
        womanLedDisbursedList: [],
      };
    }

    let accountDisbursedList = r.accountDisbursedList.filter(d => d.accountType !== 'individual')
    let accountDisbursedListR = r.accountDisbursedList.filter(d => d.accountType === 'individual')

    console.log('Retail Loan List: ', accountDisbursedListR)

    this.setState({
      errorList: response.errorList,
      totalDisbursement: r,
      accountDisbursedList: accountDisbursedList,
      accountDisbursedListR: accountDisbursedListR,
      purposeDisbursedList: r.purposeDisbursedList,
      invDiscountDisbursedList: r.invDiscountDisbursedList,
      womanLedDisbursedList: r.womanLedDisbursedList
    })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Disbursements(this.props.context.filter))
    this.setState({ accountDisbursedList: null, accountDisbursedListR: null, purposeDisbursedList: null, womanLedDisbursedList: null, errorList: null, totalDisbursement: null },
      () => {
        this.getDisbursements(this.props.context, this.props.context.filter)
      }
    )
  }

}

export default withRouter(DistributionPageSF)
